// Package identity. The project file format version is PROJECT_VERSION (schema.ts).
// GPL-3.0-or-later.
export const ENGINE = { name: "@dipfield/project", version: "2.7.0" } as const;
